import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBranches } from "../../store/about/aboutAction";
import Loader from "../../component/Loader";
import { Link } from "react-router-dom";
import bg from "../../assets/pexels-max-fischer-5212345.jpg";
import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";

const SingleEvent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { branches, loading } = useSelector((state) => state.aboutSlicer);

  useEffect(() => {
    dispatch(getBranches(lan));
  }, [dispatch, lan]);

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Web Development</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <a class="section-16px-regular font-weight-500" href="#">
                    Home
                  </a>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">
                    Services Single
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-service-details">
        <div class="container">
          <div class="row">
            <div class="col-md-11">
              <article class="post-inner">
                <div class="post-media">
                  <img src={img5} alt="images" />
                </div>
                <div class="post-content margin-bottom-38">
                  <h2 class="section-24px-montserrat">Web Development </h2>
                  <p class="margin-top-17 margin-bottom-17">
                    We denounce with righteous indige nation and dislike men who
                    are so beguiled and demo realized by the charms of pleasure
                    of the moment, so blinded by desire, that they cannot
                    foresee the pain and trouble that are bound to ensue cannot
                    foresee. These cases are perfectly simple and easy to
                    distinguish. In a free hour, when our power of choice is
                    untrammelled data structures manages data in technology.
                  </p>
                  <p class="margin-bottom-27">
                    Epsum factorial non deposit quid pro quo hic escorol.
                    Olypian quarrels et gorilla congolium sic ad nauseum.
                    Souvlaki ignitus carborundum e pluribus unum. Defacto lingo
                    est igpay atinlay. Marquee selectus non provisio incongruous
                    feline nolo contendre. Gratuitous octopus niacin, sodium
                    glutimate. Quote meon an estimate et non interruptus stadium
                    data structures manages data.
                  </p>
                  <h3 class="section-20px-montserrat font-weight-500 margin-bottom-15">
                    Digital Technology on The Cutting Edge
                  </h3>
                  <p>
                    We denounce with righteous indige nation and dislike men who
                    are so beguiled and demo realized by the charms of pleasure
                    of the moment, so blinded by desire, that they cannot
                    foresee the pain and trouble that are bound to ensue cannot
                    foresee. These cases are perfectly simple and easy to
                    distinguish. In a free hour, when our power of choice is
                    untrammelled data structures manages data in technology.
                  </p>
                  <ul class="post-question">
                    <li>
                      <a href="service-single.html">
                        How will digital activities impact traditional
                        manufacturing.
                      </a>
                    </li>
                    <li>
                      <a href="service-single.html">
                        All these digital elements and projects aim to enhance .
                      </a>
                    </li>
                    <li>
                      <a href="service-single.html">
                        I monitor my staff with software that takes screenshots.
                      </a>
                    </li>
                    <li>
                      <a href="service-single.html">
                        Laoreet dolore magna niacin sodium glutimate aliquam
                        hendrerit.
                      </a>
                    </li>
                    <li>
                      <a href="service-single.html">
                        Minim veniam quis niacin sodium glutimate nostrud exerci
                        dolor.
                      </a>
                    </li>
                  </ul>
                  <div class="post-quotes margin-bottom-18">
                    <p class="font-weight-700">
                      Gratuitous octopus niacin, sodium glutimate. Quote meon an
                      estimate et non interruptus stadium data structures
                      manages data lingo est igpay atinlay marquee.
                    </p>
                  </div>
                  <p>
                    We denounce with righteous indige nation and dislike men who
                    are so beguiled and demo realized by the charms of pleasure
                    of the moment, so blinded by desire, that they cannot
                    foresee the pain and trouble that are bound to ensue cannot
                    foresee. These cases are perfectly simple and easy to
                    distinguish. In a free hour, when our power of choice is
                    untrammelled data structures manages data in technology.
                  </p>
                </div>
              </article>
            </div>

            <section class="flat-latest ">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="section-title">
                      <h4 class="section-subtitle margin-bottom-15">
                        Latest News
                      </h4>
                      <h2 class="section-45px-montserrat ">
                        Latest Blog Posts
                      </h2>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img2} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Lights winged seasons fish abundantly.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img3} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Winged moved stars, fruit creature seed night.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="latest-new-box grow-up-hover">
                      <div class="latest-post">
                        <img src={img4} class="grow-up-hover" alt="images" />
                      </div>
                      <div class="latest-content">
                        <div class="latest-info link-style-6 margin-bottom-10">
                          <span>
                            <a
                              href="blog.html"
                              class="author-post section-14px-regular font-weight-500"
                            >
                              Personal
                            </a>
                          </span>
                          <span>
                            <a
                              href="blog.html"
                              class="date-post section-14px-regular font-weight-500"
                            >
                              June 13, 2021
                            </a>
                          </span>
                        </div>
                        <div class="latest-title margin-bottom-20">
                          <a
                            href="blog-single.html"
                            class="section-20px-montserrat"
                          >
                            Given void great you’re good appear also fifth.
                          </a>
                        </div>
                        <div class="latest-readmore">
                          <a href="blog-single.html" class="read-more"></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default SingleEvent;
